import { z } from '@hono/zod-openapi';
const nonEmptyString = z.string().min(1);
const timestampString = z.string().datetime();
export const predictionTriggerReasonSchema = z.enum(['scheduled_early', 'lineup_changed']);
export const prematchSnapshotActionSchema = z.enum(['fetch_prediction', 'fetch_lineup', 'none']);
export const lineupAvailabilityStateSchema = z.enum([
    'pending',
    'available',
    'unavailable',
    'provider_failed',
    'rate_limited',
    'invalid_payload',
]);
export const normalizedLineupPlayerSchema = z.object({
    id: z.number().int().nullable(),
    name: nonEmptyString,
    number: z.number().int().nullable(),
    pos: z.string().nullable(),
    grid: z.string().nullable(),
});
export const normalizedLineupTeamSchema = z.object({
    id: z.number().int().nullable(),
    name: nonEmptyString,
});
export const normalizedLineupCoachSchema = z.object({
    id: z.number().int().nullable(),
    name: z.string().nullable(),
});
export const normalizedTeamLineupSchema = z.object({
    team: normalizedLineupTeamSchema,
    formation: z.string().nullable(),
    coach: normalizedLineupCoachSchema.nullable(),
    startXI: z.array(normalizedLineupPlayerSchema),
    substitutes: z.array(normalizedLineupPlayerSchema),
});
export const fixturePredictionSnapshotSchema = z.object({
    predictionSnapshotId: nonEmptyString,
    apiFootballFixtureId: z.number().int().positive(),
    footballFixtureId: z.string().nullable(),
    triggerReason: predictionTriggerReasonSchema,
    fetchedAt: timestampString,
    providerTimestamp: timestampString.nullable(),
    rawPayloadArchiveId: nonEmptyString,
    predictionSummary: z.record(z.string(), z.unknown()),
    sourceLineupSnapshotId: z.string().nullable(),
    normalizationVersion: nonEmptyString,
});
export const fixtureLineupSnapshotSchema = z.object({
    lineupSnapshotId: nonEmptyString,
    apiFootballFixtureId: z.number().int().positive(),
    footballFixtureId: z.string().nullable(),
    fetchedAt: timestampString,
    providerTimestamp: timestampString.nullable(),
    rawPayloadArchiveId: nonEmptyString,
    availabilityState: lineupAvailabilityStateSchema,
    lineupDiffHash: nonEmptyString.nullable(),
    normalizedLineups: z.array(normalizedTeamLineupSchema),
    normalizationVersion: nonEmptyString,
});
export const prematchSnapshotLatestStateSchema = z.object({
    apiFootballFixtureId: z.number().int().positive(),
    latestPrediction: fixturePredictionSnapshotSchema.nullable(),
    latestLineup: fixtureLineupSnapshotSchema.nullable(),
    nextScheduledAction: z.object({
        action: prematchSnapshotActionSchema,
        triggerReason: predictionTriggerReasonSchema.nullable(),
        reason: z.string().nullable(),
    }),
    generatedAt: timestampString,
});
export const prematchSnapshotLatestStateQuerySchema = z.object({
    apiFootballFixtureId: z.coerce.number().int().positive(),
});
